import PlateReferenceCard from './PlateReferenceCard';

export default PlateReferenceCard;
